import React from 'react';

const Header = ({ onShowHelpGuide }) => {
  return (
    <header className="App-header">
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', maxWidth: '1200px', margin: '0 auto', padding: '0 20px' }}>
        <h1>🎓 Mapa de Abogacía UBA</h1>
        <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
          {/* Botón de ayuda siempre disponible */}
          <button
            onClick={onShowHelpGuide}
            style={{
              padding: '8px 16px',
              backgroundColor: 'transparent',
              border: '2px solid var(--text-inverse)',
              borderRadius: '20px',
              color: 'var(--text-inverse)',
              cursor: 'pointer',
              fontSize: '0.9em',
              fontWeight: '500',
              transition: 'all 0.2s ease'
            }}
            onMouseOver={(e) => {
              e.target.style.backgroundColor = 'var(--text-inverse)';
              e.target.style.color = 'var(--bg-header)';
            }}
            onMouseOut={(e) => {
              e.target.style.backgroundColor = 'transparent';
              e.target.style.color = 'var(--text-inverse)';
            }}
          >
            ❓ Ayuda
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;
